export const SPECIFIC_COHORT_ID = 'bf486817-5c58-491f-812e-e8b9af91ec34';
export const YOUTUBE_PLAYLIST_ITEMS_API = 'https://www.googleapis.com/youtube/v3/playlistItems';
export const YOUTUBE_PLAYLIST_ID = 'PLN2xt9HyWoMp2p0smViEEgJIQx9g5Yn8P';
export const YOUTUBE_MAX_RESULTS = 40;
